module.exports = __webpack_public_path__ + "img/instruction1.71c1341d.png";